module Meevo.Plugins.AlertsManager {
    'use strict';
    import EmployeeCategory = Meevo.Model.EmployeeCategory;
    import SecurityAccessEnum = Meevo.Model.SecurityAccessEnum;
    import EmployeeSearchView = Meevo.Model.EmployeeSearchView;

    class MeevoFilterUsersComponent implements ng.IComponentController {
        static $inject = [
            '$scope',
            'meevo.plugins.alertsManager.AlertsManagerService',
        ];

        public params: IParams;
        public modelName: string;
        public modelUsersName: string;

        public employeeCriteria = {
            includeInactive: true,
            view: EmployeeSearchView.AllEmployeesWithCategories,
        };

        public usersOnlyCriteria = {
            includeInactive: true,
            view: EmployeeSearchView.Default,
            showEmployeesOnly: null
        }

        public selectedEmployeeCategory: EmployeeCategory;

        public isReceivedByModelName: boolean;

        public get labelTriggeredBy(): string {
            const enumDto = this.alertsManagerService.triggeredByLabels.find((item) => item.id === this.params.alertSetting.systemAlertTriggeredType);
            if (!enumDto) {
                return '';
            }

            return enumDto.displayName;
        }

        constructor(
            private $scope: ng.IScope,
            protected alertsManagerService: IAlertsManagerService,
        ) {
        }

        $onInit() {
            this.isReceivedByModelName = this.modelName === "ReceivedBy";
        }

        get isRequired(): boolean {
            if (this.modelName === 'TriggeredBy') {
                return !(this.params.allUsersAreSelectedTriggeredBy || this.params.triggeredByList.length || this.params.triggeredUsersByList.length);
            } else if (this.modelName === 'ReceivedBy') {
                return !(this.params.allUsersAreSelectedReceivedBy || this.params.receivedByList.length || this.params.receivedUsersByList.length);
            }
        }

        set userFilterModel(value) {
            this.params['userFilter' + this.modelName] = value;
        }

        set allUsersAreSelectedModel(value) {
            this.params['allUsersAreSelected' + this.modelName] = value;
        }

        get userFilterModel() {
            return this.params['userFilter' + this.modelName];
        }

        get allUsersAreSelectedModel() {
            return this.params['allUsersAreSelected' + this.modelName];
        }

        get securityAccessEnum(): any {
            return SecurityAccessEnum;
        }

        get userFilterEnum(): any {
            return UserFilterEnum;
        }

        get paramsModelName(): string {
            return this.modelName.slice(0, 1).toLowerCase() + this.modelName.slice(1) + 'List';
        }

        get paramsModelUsersName(): string {
            return this.modelUsersName.slice(0, 1).toLowerCase() + this.modelUsersName.slice(1) + 'List';
        }

        get hideAllSelected(): boolean {
            return this.isReceivedBy;
        }

        get showServiceScheduledWith(): boolean {
            if (this.params.alertSetting && !_.isUndefined(this.params.alertSetting.id)) {
                return this.isReceivedBy && this.alertHasServicingEmployee;
            }
        }

        get minLengthMover(): number {
            return this.allUsersAreSelectedModel ? 0 : 1;
        }

        get showUsersAreSelected(): boolean {
            if (this.isReceivedBy && this.params.alertSetting && !_.isUndefined(this.params.alertSetting.id)) {
                return !this.alertHasServicingEmployee;
            }

            return true;
        }

        get isReceivedBy(): boolean {
            return this.modelName === 'ReceivedBy';
        }

        get alertHasServicingEmployee(): boolean {
            return this.params.alertSetting && this.params.alertSetting.hasServicingEmployee;
        }

        setAllUsers(isAllUsersAreSelectedModel: boolean) {
            this.params.allUsersAreSelectedReceivedBy = this.modelName === 'ReceivedBy' ? isAllUsersAreSelectedModel : this.params.allUsersAreSelectedReceivedBy;
            this.params.allUsersAreSelectedTriggeredBy = this.modelName === 'TriggeredBy' ? isAllUsersAreSelectedModel : this.params.allUsersAreSelectedTriggeredBy;
            this.params.triggeredByAllEmployees = this.params.allUsersAreSelectedReceivedBy || this.params.allUsersAreSelectedTriggeredBy;
        }
        /**
         * Parse data and add user_TId as a copy from id
         * @param {Array<any>} list
         */
        extendData(list: Array<any>) {
            if (!angular.isArray(list) || list.length === 0) return;

            list.forEach(i => {
                i.user_TId = i.id;
            });
        }

        $onChanges(changes) {
            if (changes.isSystemUserSelected && changes.isSystemUserSelected.currentValue) {
                this.allUsersAreSelectedModel = false;
            }

            if (changes.notApplicable && changes.notApplicable.currentValue === true) {
                this.allUsersAreSelectedModel = true;
            }
        }
    }

    angular.module('meevo.plugins.alertsManager')
        .component('meevoFilterUsersComponent', <angular.IComponentOptions>{
            templateUrl: 'app/plugins/alertsManager/addNewAlert/tabs/filter-users-tab/filter-users-tab.component.html',
            controller: MeevoFilterUsersComponent,
            controllerAs: '$ctrl',
            bindings: {
                params: '<',
                titleDiv: '@',
                modelName: '@',
                modelUsersName: '@',
                isSystemUserSelected: '<',
                notApplicable: '<'
            }
        });
}
